import React from "react";
import { useLocation, useNavigate } from "react-router";
import { push, ref } from "firebase/database";
import { ArrowLeft } from "lucide-react";

import ClientForm from "../forms/ClientForm";
import { useNotification } from "../../contexts/NotificationContext";
import { database } from "../../firebase/firebase";
import { Button } from "../../components/ui/button";

export default function AddClientPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const { showNotification } = useNotification();

  const { data } = location.state || {};

  const goBack = () => navigate("/admin-management");

  const handleAdd = (payload: any) => {
    push(ref(database, "booking"), payload)
      .then(() => {
        goBack();
        showNotification("success", "Reserva adicionada com sucesso!");
      })
      .catch(() =>
        showNotification("error", "Um erro aconteceu ao criar essa reserva.")
      );
  };

  return (
    <div className="min-h-screen bg-slate-950 px-4 py-6 text-white">
      <header className="mb-6 flex items-center gap-3">
        <Button
          variant="ghost"
          size="icon"
          className="text-white hover:bg-white/10"
          onClick={goBack}
        >
          <ArrowLeft className="h-5 w-5" />
        </Button>
        <div>
          <p className="text-xs uppercase tracking-[0.4em] text-white/60">
            Nova reserva
          </p>
          <h1 className="text-2xl font-semibold">Adicionar cliente</h1>
        </div>
      </header>
      <ClientForm body={data} onAdd={handleAdd} />
    </div>
  );
}
